import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-536f049a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "create-result-form"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-arrow-left" }, null, -1))
const _hoisted_3 = { class: "ms-2 text-lowercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MrUiKitButton = _resolveComponent("MrUiKitButton")!
  const _component_TeamForm = _resolveComponent("TeamForm")!
  const _component_MrUiKitTab = _resolveComponent("MrUiKitTab")!
  const _component_SingleForm = _resolveComponent("SingleForm")!
  const _component_MrUiKitNavTab = _resolveComponent("MrUiKitNavTab")!

  return (_ctx.isMounted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MrUiKitButton, {
          onClick: _ctx.onBack,
          classes: ['btn-link', 'text-secondary', 'back-button', 'mt-4']
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.t('common.operations.back')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.mode === 'new')
          ? (_openBlock(), _createBlock(_component_MrUiKitNavTab, {
              key: 0,
              mode: "tab",
              onTabClicked: _ctx.onChangeTab
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MrUiKitTab, {
                  name: _ctx.t('common.tabs.result')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TeamForm, {
                      entity: _ctx.entity,
                      hideBack: true,
                      onBack: _ctx.onBack
                    }, null, 8, ["entity", "onBack"])
                  ]),
                  _: 1
                }, 8, ["name"]),
                _createVNode(_component_MrUiKitTab, {
                  name: _ctx.t('common.tabs.otherResult')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SingleForm, {
                      entity: _ctx.entity,
                      hideBack: true,
                      onBack: _ctx.onBack
                    }, null, 8, ["entity", "onBack"])
                  ]),
                  _: 1
                }, 8, ["name"])
              ]),
              _: 1
            }, 8, ["onTabClicked"]))
          : (_ctx.mode === 'team')
            ? (_openBlock(), _createBlock(_component_TeamForm, {
                key: 1,
                value: _ctx.value,
                entity: _ctx.entity,
                hideBack: true,
                onBack: _ctx.onBack
              }, null, 8, ["value", "entity", "onBack"]))
            : (_ctx.mode === 'single')
              ? (_openBlock(), _createBlock(_component_SingleForm, {
                  key: 2,
                  value: _ctx.value,
                  entity: _ctx.entity,
                  hideBack: true,
                  onBack: _ctx.onBack
                }, null, 8, ["value", "entity", "onBack"]))
              : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}